

let projectCarousel = document.querySelector(".js-project-carousel");
const siteLogo = document.querySelector(".js-site-logo"),
closeBtn = document.querySelector(".js-overlay-close");
    
    if(typeof(projectCarousel) != 'undefined' && projectCarousel != null){

        imagesLoaded( projectCarousel, function() {
            //console.log('all images are loaded');
            loadTitle(projectCarousel);
        });
        
        let projectChapters = projectCarousel.querySelectorAll(".project-chapter"),
            chapters = [],
            audioButton = projectCarousel.querySelector(".js-audio-button"),
            btsButton = projectCarousel.querySelector(".js-bts-button");

            createChapters(projectChapters,chapters);
            chapterNavigation(chapters);
            const firstChapterColor = chapters[0].color; 
            chapterColor(firstChapterColor);

            const spotlights = document.querySelectorAll('.js-spotlight-rollover');
            
            spotlights.forEach((spotlight) => { 
               spotlight.addEventListener('mousemove', spotlightMove);
               spotlight.addEventListener('mouseleave', spotlightLeave);

                let rect = spotlight.getBoundingClientRect();
                let center = {
                    w: Math.round(rect.width * 0.5),
                    h: Math.round(rect.height * 0.5)
                }
                let spot = spotlight.querySelector('.js-spotlight');

                TweenMax.set( spot, {
                    xPercent: -50,
                    yPercent: -50,
                    x: center.w,
                    y: center.h,
                    ease: Back.easeOut.config(1.4)
                } );

                window.addEventListener('resize', function() {
                    TweenMax.set( spot, {
                        xPercent: -50,
                        yPercent: -50,
                        x: center.w,
                        y: center.h,
                        ease: Back.easeOut.config(1.4)
                    } );
                });
            });

            const textChapters = document.querySelectorAll('.js-text-chapter'); 
            textChapters.forEach((chapter) => {
                textChapter(chapter);
            });

            if(typeof(audioButton) != 'undefined' && audioButton != null){
                projectAudio(audioButton);
            }

            if(typeof(btsButton) != 'undefined' && btsButton != null){
                behindTheScenes(btsButton);
            }
            
            
    }		



    function spotlightMove(e) { 

        let spot = this.querySelector('.js-spotlight');
    
        TweenMax.to(spot, 0.8, {
            x: e.offsetX,
            y: e.offsetY,
            ease:Power4.easeOut
        });

    }

    function spotlightLeave() {
        var rect = this.getBoundingClientRect();
        var center = {
            w: Math.round(rect.width * 0.5),
            h: Math.round(rect.height * 0.5)
        }
        let spot = this.querySelector('.js-spotlight');
        
        TweenMax.to( spot, 0.8, {
            x: center.w,
            y: center.h,
            ease:Power4.easeOut
        });
    }

    function projectAudio(audioButton) { 
        const audioPlayer = projectCarousel.querySelector(".js-audio-player");
        let isAudioPlaying = false;
        audioButton.addEventListener("click", () => {
            isAudioPlaying = !isAudioPlaying;
            audioButton.classList.toggle('project-carousel__audio--playing');
            if (isAudioPlaying) {
                audioPlayer.play();
            } else {
                audioPlayer.pause();
            }
        });
    }

    function behindTheScenes(btsButton) {
        const btsOverlay = projectCarousel.querySelector(".js-bts-overlay"),
            btsClose = projectCarousel.querySelector(".js-bts-overlay-close");
        
        btsButton.addEventListener("click", () => {
            if (closeBtn) {
                gsap.to(closeBtn, 0.3, {autoAlpha: 0});
            }
            gsap.to(btsOverlay, 0.3, {autoAlpha: 1});
            gsap.to(menuButton, 0.3, {autoAlpha: 0});
            gsap.to(btsClose, 0.3, {autoAlpha: 1});
            
        });

        btsClose.addEventListener("click", () => {
            gsap.to(btsOverlay, 0.3, {autoAlpha: 0});
            gsap.to(menuButton, 0.3, {autoAlpha: 1});
            gsap.to(btsClose, 0.3, {autoAlpha: 0});
            if (closeBtn) {
                gsap.to(closeBtn, 0.3, {autoAlpha: 1});
            }
        });
    }


    function createChapters(projectChapters,chapters) {
        projectChapters.forEach((chapter) => { 
            chapter.style.height = height + 'px';

            let chapterColor = chapter.dataset.color;
            let chapterType = chapter.dataset.type;
            chapters.push({
                el:chapter,
                color:chapterColor,
                type:chapterType
            });	
        });

       // console.log(chapters);
    }


	function chapterNavigation(chapters) {		

        const chapterCount = chapters.length - 1,
            chapterNav = projectCarousel.querySelectorAll(".js-chapter-nav"),
            chapterCounter = document.querySelector(".js-chapter-counter");

        let oldChapter = 0,
            newChapter = 0;
            
        chapterNav.forEach((btn) => {
            btn.addEventListener("click", (e) => {
                e.preventDefault();

                // get the direction
                let direction = btn.dataset.dir;

                newChapter = newNumber(newChapter,chapterCount,direction);
                
                chapterCounter.innerHTML = newChapter + 1;
                
                updateUI(newChapter,chapterCount);
                updateSlide(chapters[oldChapter],chapters[newChapter]);

                oldChapter = newChapter;

            })
        });

        document.onkeydown = checkKey;

        function checkKey(e) {
            e = e || window.event;
            let direction;
            
            if (e.keyCode == '37') {
                // left arrow
                if (newChapter > 0) {
                    direction = 'prev';
                    newChapter = newNumber(newChapter,chapterCount,direction);
                    updateUI(newChapter,chapterCount);
                    updateSlide(chapters[oldChapter],chapters[newChapter]);
                    oldChapter = newChapter;
                }
            }
            else if (e.keyCode == '39') {
                // right arrow
                if (newChapter < chapterCount) {
                    direction = 'next';
                    newChapter = newNumber(newChapter,chapterCount,direction);
                    updateUI(newChapter,chapterCount);
                    updateSlide(chapters[oldChapter],chapters[newChapter]);
                    oldChapter = newChapter;
                }
            }
            //console.log(newChapter + ' / ' + chapterCount);

            chapterCounter.innerHTML = newChapter + 1;
        }

        

    }
    
    
    function newNumber(newChapter,chapterCount,direction) {

        if (direction == 'prev') {
            if (newChapter > 0) {
                newChapter--;
            }
        } else {
            if (newChapter < chapterCount) {
                newChapter++;
            }
        }
        return newChapter;

    }

    function updateUI(newChapter,chapterCount) {

        let btsText = projectCarousel.querySelector(".js-bts-text"),
        nextSlideBtn = projectCarousel.querySelector(".project-carousel__nav--next"),
        prevSlideBtn = projectCarousel.querySelector(".project-carousel__nav--prev"),
        closeSlideBtn = projectCarousel.querySelector(".project-carousel__nav--close");

        if (newChapter == 0) {
            prevSlideBtn.classList.add('project-carousel__nav--inactive');
            nextSlideBtn.classList.add('project-carousel__nav--pulse');
            if (btsText) {
                gsap.to(btsText, 0.2, { autoAlpha: 1, ease: Power1.easeInOut });
            }
        }

        if ((newChapter > 0) && (newChapter < chapterCount)) {
            prevSlideBtn.classList.remove('project-carousel__nav--inactive');
            nextSlideBtn.classList.remove('project-carousel__nav--inactive');
            nextSlideBtn.classList.remove('project-carousel__nav--pulse');
            if (btsText) {
                gsap.to(btsText, 0.2, { autoAlpha: 0, ease: Power1.easeInOut });
            }
        }
    
        if (newChapter == (chapterCount)) {
            nextSlideBtn.classList.add('project-carousel__nav--inactive');
            closeSlideBtn.classList.remove('project-carousel__nav--inactive');
        } else {
            closeSlideBtn.classList.add('project-carousel__nav--inactive');
        }
    }

    function updateSlide(oldChapter,newChapter) {
        
        let oldChapterType = oldChapter.type;
        if (oldChapterType == 'title') {
            unloadTitle(oldChapter.el,newChapter);
        } else if (oldChapterType == 'spotlight') {
            unloadSpotlight(oldChapter.el,newChapter);
        } else if (oldChapterType == 'textImages') {
            unloadTextImages(oldChapter.el,newChapter);
        } else if (oldChapterType == 'imagery') {
            unloadImagery(oldChapter.el,newChapter);
        } else if (oldChapterType == 'video') {
            unloadVideo(oldChapter.el,newChapter);
        } else if (oldChapterType == 'testimonial') {
            unloadTestimonial(oldChapter.el,newChapter);
        }


    }

    function loadTitle(elem) {

        const loadTitleChapter = gsap.timeline(),
            projectTitle = elem.querySelector(".js-project-title"),
            projectIntro = elem.querySelector(".js-project-intro"),
            projectImage = elem.querySelector(".js-project-image"),
            projectInfo = elem.querySelector(".js-project-info"),
            //projectKeyboard = document.querySelector(".js-keyboard"),
            projectUI = elem.querySelectorAll(".js-project-UI");

            loadTitleChapter.to( projectImage, 0.4, { 'opacity': '0.9' })
                .to( projectTitle, 1, { autoAlpha: 1 }, '-=0.2')
                .to( projectIntro, 1, { autoAlpha: 1 }, '-=0.4')
                .to( projectInfo, 0.2, { autoAlpha: 1 }, '-=0.4')
                .to( projectUI, 0.2, { autoAlpha: 1 }, '-=0.2');
    }

    function unloadTitle(elem,newChapter) {

        const unloadTitleChapter = gsap.timeline(),
            projectTitle = elem.querySelector(".js-project-title"),
            projectIntro = elem.querySelector(".js-project-intro"),
            projectImage = elem.querySelector(".js-project-image"),
            //projectKeyboard = document.querySelector(".js-keyboard"),
            projectInfo = elem.querySelector(".js-project-info");

            unloadTitleChapter.to( projectInfo, 0.2, { 'opacity': '0' })
                //.to( projectKeyboard, 0.2, { autoAlpha: 0 }, '-=0.2')
                .to( projectIntro, 0.2, { autoAlpha: 0 }, '-=0.2')
                .to( projectTitle, 0.2, { autoAlpha: 0 }, '-=0.2')
                .to( projectImage, 0.2, { 'opacity': '0', onComplete: closeChapterAnimations,onCompleteParams: [elem,newChapter] }, '-=0.2');

    }


    function loadSpotlight(elem) {

        const loadSpotlightChapter = gsap.timeline(),
            spotlightImage = elem.querySelector(".js-spotlight-image"),
            spotlightTitle = elem.querySelector(".js-spotlight-title"),
            spotlightCopy = elem.querySelector(".js-spotlight-copy");

            loadSpotlightChapter.to( spotlightImage, 0.2, { autoAlpha: 1 })
                .fromTo( spotlightCopy, 0.4, {autoAlpha: 0, y:20}, { autoAlpha: 1, y:0 }, '-=0.1')
                .to( spotlightTitle, 0.4, { autoAlpha: 1, onComplete: chapterAnimationsComplete }, '-=0.2');

        }


    function unloadSpotlight(elem,newChapter) {

        const unloadSpotlightChapter = gsap.timeline(),
            spotlightImage = elem.querySelector(".js-spotlight-image"),
            spotlightTitle = elem.querySelector(".js-spotlight-title"),
            spotlightCopy = elem.querySelector(".js-spotlight-copy");
           // projectKeyboard = document.querySelector(".js-keyboard")
            

            unloadSpotlightChapter.to( spotlightTitle, 0.2, { autoAlpha: 0 })
                .fromTo( spotlightCopy, 0.4, {autoAlpha: 1, y:0}, { autoAlpha: 0,y:20 }, '-=0.2')
                .to( spotlightImage, 0.4, { autoAlpha: 0, onComplete: closeChapterAnimations,onCompleteParams: [elem,newChapter] }, '-=0.4');
               

        }
    
    function loadTextImages(elem) {

        const loadTextImageChapter = gsap.timeline(),
            textImagesText = elem.querySelector(".js-textimages-text"),
            textImagesImage = elem.querySelector(".js-textimages-image"),
            textImagesBG = elem.querySelector(".js-textimages-background");

            loadTextImageChapter.to( textImagesBG, 0.2, { autoAlpha: 1 })
                .to( textImagesImage, 0.2, { autoAlpha: 1 }, '-=0.2')
                .fromTo( textImagesText, 0.4, {autoAlpha: 0, y:20}, { autoAlpha: 1, y:0, onComplete: chapterAnimationsComplete }, '-=0.2');

        }

    function unloadTextImages(elem,newChapter) {

        const unloadTextImageChapter = gsap.timeline(),
            textImagesText = elem.querySelector(".js-textimages-text"),
            textImagesImage = elem.querySelector(".js-textimages-image"),
            textImagesBG = elem.querySelector(".js-textimages-background");

            unloadTextImageChapter.fromTo( textImagesText, 0.2, {autoAlpha:1, y:0}, { autoAlpha: 0, y:20 })
                .to( textImagesImage, 0.2, { autoAlpha: 0 }, '-=0.2')
                .to( textImagesBG, 0.4, { autoAlpha: 0, onComplete: closeChapterAnimations,onCompleteParams: [elem,newChapter]  }, '-=0.2');

        }

    function loadImagery(elem) {

        const loadImageryChapter = gsap.timeline(),
        imageryItem = elem.querySelectorAll(".js-imagery-item");

            loadImageryChapter.to( imageryItem, 0.4, { autoAlpha: 1, stagger: 0.1, onComplete: chapterAnimationsComplete });

        }


    function unloadImagery(elem,newChapter) {

        const unloadImageryChapter = gsap.timeline(),
        imageryItem = elem.querySelectorAll(".js-imagery-item");

        unloadImageryChapter.to( imageryItem, 0.4, { autoAlpha: 0, stagger: 0.1, onComplete: closeChapterAnimations,onCompleteParams: [elem,newChapter]  });

        }
    

    function loadVideo(elem) {

        const loadVideoChapter = gsap.timeline(),
        videoImage = elem.querySelector(".js-video-image"),
        videoButton = elem.querySelector(".js-play-embed");

            loadVideoChapter.to( videoImage, 0.2, { autoAlpha: 1 })
            .fromTo( videoButton, 0.2, { autoAlpha: 0, y:20}, { autoAlpha: 1, y:0, onComplete: chapterAnimationsComplete }, '+=0');

            // console.log(videoElems.length);
            // if (videoElems.length > 0) {
            //     for(let i = 0; i < videoElems.length; i++){
            //         //videoElems[i].play(); 

            //         let promise = videoElems[i].play();

            //         if (promise !== undefined) {
            //             promise.then(function() {
            //                 // if(videoReplayButton != null && videoReplayButton != undefined){
            //                 //     //Display Replay button 
            //                 //     videoReplayButton.enabled = true;
            //                 // }
            //                 videoElems[i].play();
            //             }).catch(function(error) {
            //                 //If there was an error autoplaying the video, then display a button to play the video
            //                 // if(videoPlayButton != null && videoPlayButton != undefined){
            //                 //     videoPlayButton.enabled = true;
            //                 // }
            //             });
            //         }

            //     }
            // }

            // let videoElems = document.getElementsByClassName('inline-video');
                
            // if (videoElems.length > 0) {
            //     inlineVideo();
            // }

            // let chapterVideoElems = elem.querySelectorAll('.inline-video');
            // console.log(chapterVideoElems);
	
            // if (chapterVideoElems.length > 0) {
            //     for(let i = 0; i < chapterVideoElems.length; i++){ //console.log(videoElems[i]);
                    
            //         chapterVideoElems[i].addEventListener('canplay', function() {
            //             chapterVideoElems[i].classList.add('inline-video--ready');console.log('canplay');
            //             chapterVideoElems[i].play(); 
            //         });
            
            //         chapterVideoElems[i].addEventListener('pause', function() {console.log('paused');
            //             chapterVideoElems[i].play(); 
            //         });
                            
            //         if (chapterVideoElems[i].readyState > 3) { 
            //             chapterVideoElems[i].classList.add('inline-video--ready');console.log('ready state 3');
            //             chapterVideoElems[i].play(); 
            //         }

            //         //chapterVideoElems[i].play(); 
            
            //     }
            // }

    }

    function unloadVideo(elem,newChapter) {

        // Pause any Vimeo Players
        if (vimeoPlayer) {
            vimeoPlayer.pause();
        }
        
        // pause any YT players
        for (let i = 0; i < players.length; i++) {
            players[i].pauseVideo();
        }
        
        if (videoEmbed) {
            TweenMax.to($('.js-embed-overlay'), 0.4, { autoAlpha:0 });
        }
        const loadVideoChapter = gsap.timeline(),
        videoImage = elem.querySelector(".js-video-image"),
        videoButton = elem.querySelector(".js-play-embed");

        loadVideoChapter.fromTo( videoButton, 0.2, { autoAlpha: 1, y:0}, { autoAlpha: 0, y:20 })
        .to( videoImage, 0.2, { autoAlpha: 0, onComplete: closeChapterAnimations, onCompleteParams: [elem,newChapter]  }, '-=0.2');

    }


    function loadTestimonial(elem) {

        const loadTestimonialChapter = gsap.timeline(),
        testimonialImage = elem.querySelector(".js-testimonial-image"),
        testimonialText = elem.querySelector(".js-testimonial-text");

            loadTestimonialChapter.to( testimonialImage, 0.2, { autoAlpha: 1 })
            .fromTo( testimonialText, 0.2, { autoAlpha: 0, x:20}, { autoAlpha: 1, x:0, onComplete: chapterAnimationsComplete }, '+=0');

    }


    function unloadTestimonial(elem,newChapter) {

        const loadTestimonialChapter = gsap.timeline(),
        testimonialImage = elem.querySelector(".js-testimonial-image"),
        testimonialText = elem.querySelector(".js-testimonial-text");

            loadTestimonialChapter.fromTo( testimonialText, 0.2, { autoAlpha: 1, x:0}, { autoAlpha: 0, x:20 })
            .to( testimonialImage, 0.2, { autoAlpha: 0, onComplete: closeChapterAnimations, onCompleteParams: [elem,newChapter]  }, '+=0');

    }
    
    
    function closeChapterAnimations(elem,newChapter) {
        //console.log('closing ' + oldChapter.type);
        elem.classList.remove('project-chapter--active');

        newChapter.el.classList.add('project-chapter--active');

        let newChapterType = newChapter.type;
        if (newChapterType == 'title') {
            loadTitle(newChapter.el);
        } else if (newChapterType == 'spotlight') {
            loadSpotlight(newChapter.el);
        } else if (newChapterType == 'textImages') {
            loadTextImages(newChapter.el);
        } else if (newChapterType == 'imagery') {
            loadImagery(newChapter.el);
        } else if (newChapterType == 'video') {
            loadVideo(newChapter.el);
        } else if (newChapterType == 'testimonial') {
            loadTestimonial(newChapter.el);
        }

        chapterColor(newChapter.color);
    }

    function chapterAnimationsComplete() {
        //console.log('done');
    }

    // function openChapterAnimations(activeChapter) {
    //     activeChapter
    // }

    function chapterColor(newChapterColor) {
        // remove existing theme classes
        projectCarousel.classList.remove('project-carousel--ui-dark','project-carousel--ui-light');

        // add new theme class
        if (newChapterColor == 'light') {
            projectCarousel.classList.add('project-carousel--ui-light');
            siteLogo.classList.add('header__site-logo--dark');
            if (closeBtn) {
                closeBtn.classList.add('project-overlay__close-btn--dark');
            }
            
        } else {
            projectCarousel.classList.add('project-carousel--ui-dark');
            siteLogo.classList.remove('header__site-logo--dark');
            if (closeBtn) {
                closeBtn.classList.remove('project-overlay__close-btn--dark');
            }
            
        }

    }
		
	




                
    function textChapter(chapter) {
 
        const textSections = chapter.querySelectorAll('.js-text-section'),
            textSectionLocations = [];

        textSections.forEach((section) => {
            let rect = section.getBoundingClientRect();
            let elemTop = Math.round(rect.top);
            let elemBottom = elemTop + section.offsetHeight;
            textSectionLocations.push([elemTop,elemBottom]);
       });

       const sectionImgs = chapter.getElementsByTagName("li");
       let currentSlide = 0;

        chapter.addEventListener("scroll", function(ev){

            const halfHeight = window.innerHeight/2;
            let viewportTop = ev.target.scrollTop;
            let viewportBottom = viewportTop + window.innerHeight;

            if (viewportTop > 1) {
                //console.log('scrolling');
                chapter.classList.add('text-images-chapter--scrolling');
            } else {
                chapter.classList.remove('text-images-chapter--scrolling');
            }
            
            //console.log(viewportTop);

            for( let i=0; i<textSectionLocations.length; i++ ) {

                if ((textSectionLocations[i][0] < (viewportBottom-halfHeight)) && (textSectionLocations[i][1] > (viewportTop+halfHeight))) {
                    if (i != currentSlide) {
                        sectionImgs[currentSlide].style.zIndex = '10';
                        sectionImgs[i].style.zIndex = '20';

                        sectionImgs[currentSlide].style.opacity = '0';
                        sectionImgs[i].style.opacity = '1';

                        currentSlide = i;
                    }
                }

            }
             
        });
       
    }
